import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { logError } from '@/lib/errorLogging';
import { logoutUser } from '@/utils/auth';
import { inElectron } from '@/utils/capabilities';

export const Route = createFileRoute('/error/session-expired')({
  validateSearch: z.object({
    reason: z.string().optional(),
    returnTo: z.string().optional(),
  }),
  beforeLoad: async ({ search }) => {
    const reason = search.reason ?? 'unknown';
    const returnTo = search.returnTo;
    console.error('[SessionExpired] Handling session expiry, reason:', reason);
    logError(
      new Error(`Session expired: ${reason}`),
      'Session expired - logging out user',
      {
        context: 'session-expired:beforeLoad',
        metadata: {
          reason,
          returnTo,
          platform: inElectron() ? 'electron' : 'web',
        },
      }
    );

    try {
      await logoutUser('session_expired');
    } catch (error) {
      console.error(
        '[SessionExpired] Logout error (continuing anyway):',
        error
      );
    }
    throw redirect({
      to: '/login',
      replace: true,
      search: returnTo ? { redirect: returnTo } : undefined,
    });
  },
});
